import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import router from './router';
import { getToken } from '@/utils/auth';
import i18n, { available_locales } from '@/lang';
import { setCookie } from '@/utils/cookie-helper';
import { initSocketIO } from '@/utils/socketio';
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // Take language from URL
          if (available_locales.includes(to.params.lang)) {
            i18n.locale = to.params.lang;
            setCookie('lang', to.params.lang);
          }

          // Init socketIO also before login as we need it for screen registration
          _context.next = 3;
          return initSocketIO();
        case 3:
          if (!to.params.lang) next('/' + i18n.locale);else next();
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());